import { useState, useCallback } from 'react';

export const useMigrationInterceptor = () => {
  const [showModal, setShowModal] = useState(false);
  const [actionType, setActionType] = useState('');

  const interceptAction = useCallback((action, callback) => {
    const dismissed = localStorage.getItem('scandium_migration_banner_dismissed');

    if (dismissed === 'true') {
      setActionType(action);
      setShowModal(true);
      return;
    }

    const criticalActions = ['upload_apk', 'start_emulator', 'record_test'];
    if (criticalActions.includes(action)) {
      setActionType(action);
      setShowModal(true);
      return;
    }

    if (callback) callback();
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setActionType('');
  }, []);

  return {
    interceptAction,
    showModal,
    closeModal,
    actionType
  };
};
